var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHindWare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 22,
    viewBox: "0 0 101 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.091013H2.8111V8.96511C5.09913 4.55095 12.5106 5.74395 12.5106 11.6244V20.8059H9.76221V11.9152C9.35659 6.65915 2.72962 7.85037 2.72962 12.3772V20.8989H0.0254549L0 0.091013Z",
    fill: "#627087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4177 6.64442H17.148V20.7129H14.4177V6.64442Z",
    fill: "#627087"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8884 6.54825V8.96523C24.1789 4.55092 31.5892 5.74392 31.5892 11.6244V20.806H28.8401V11.9152C28.4309 6.65912 21.805 7.85034 21.805 12.3773V20.8989H19.1033L19.0847 6.54825H21.8884Z",
    fill: "#627087"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.64 8.31134C41.5045 8.31134 43.0894 9.79296 43.6755 11.858V15.3589C43.0894 17.4217 41.5045 18.9031 39.64 18.9031C37.2824 18.9031 35.3683 16.5323 35.3683 13.6082C35.3683 10.6823 37.2824 8.31134 39.64 8.31134ZM38.9334 6.34361C40.8233 6.34361 42.4929 7.31131 43.6299 8.78429V-3.8147e-05H46.3598V20.7124H43.6299V18.656C42.4724 20.1546 40.7952 21.0981 38.9334 21.0981C35.4385 21.0981 32.6099 17.7956 32.6099 13.7191C32.6099 9.64755 35.4385 6.34361 38.9334 6.34361Z",
    fill: "#627087"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.809 6.62125L51.1437 20.7588H53.7911L57.3788 9.43936L60.9972 20.7866H63.3925L68.0038 6.70498H65.2977L62.1359 18.2458L58.6627 6.55903H56.3231L52.5371 18.2179L49.7153 6.62125C49.7153 6.62125 46.7847 6.59151 46.809 6.62125Z",
    fill: "#627087"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4623 6.54826V8.96523C84.398 7.16635 86.0732 5.99843 87.9707 6.2987L87.6577 8.67853C86.0266 8.52202 83.7983 9.74298 83.3834 12.3773V20.8989H80.6799L80.6624 6.54826H83.4623Z",
    fill: "#627087"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.958 9.41377L69.9009 6.74765C74.7166 5.88205 78.4099 6.41983 78.6915 11.2588V20.7713H75.9948V14.1984H73.0306C67.7928 14.5243 70.3072 21.1535 75.1295 17.9365L74.2418 20.3973C66.9046 22.7386 64.4074 13.3906 71.6316 12.5091C72.8596 12.3577 74.8308 12.4046 76.13 12.4046C76.6979 8.24653 72.9231 7.24828 68.958 9.41377Z",
    fill: "#627087"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8213 12.265H97.4369C97.4225 6.52091 90.5746 6.93191 89.8213 12.265ZM84.8397 14.1391H87.159C87.5178 19.8056 91.4431 21.9094 99.3329 20.0509L98.6915 18.018C92.7377 19.4489 89.7829 18.1551 89.7958 14.165H100.076C100.687 3.442 88.3688 4.23948 87.4002 12.2909H85.4545C85.4545 12.2909 84.8671 14.1945 84.8397 14.1391Z",
    fill: "#627087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHindWare);
export default __webpack_public_path__ + "static/media/hindWare.cf216d56805e625dff75710182a343c1.svg";
export { ForwardRef as ReactComponent };